import React from "react";
import { ErrorTextCard } from "@deliverr/ui-facility/lib-facility/flow/cards";
import { format } from "date-fns";
import { DateFormat } from "@deliverr/ui-facility/lib-facility/utils/dateUtils";
import { TransferPalletStatus } from "@deliverr/legacy-inbound-client";

export interface ClosePalletInvalidStatusCardProps {
  palletLabelId: string;
  status: TransferPalletStatus;
  statusUpdatedAt: Date;
  newest?: boolean;
}

export const ClosePalletInvalidStatusCard: React.FC<ClosePalletInvalidStatusCardProps> = ({
  palletLabelId,
  status,
  statusUpdatedAt,
  newest,
}) => (
  <ErrorTextCard
    title={`Pallet already ${status.toLowerCase()}!`}
    value={palletLabelId}
    message={`Pallet ${status.toLowerCase()} at ${format(statusUpdatedAt, DateFormat.TimeAndDate)}`}
    newest={newest}
  />
);
